import React, { PureComponent } from "react";
import classNames from "../../utils/classnames";

export class CellDescription extends PureComponent {
  render() {
    const { children, className, ...others } = this.props;
    const cls = classNames({
      "weui-cell__desc": true
    }, className);

    return <div className={ cls } { ...others }>{ children }</div>;
  }
}
